/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Body.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 10:13 am.
 * Last modified: 05.07.22 10:13 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { getBackgroundSettings } from '../api/helpers';
import store from '../eventStore';
import BodyJackpotPanel from './BodyJackpotPanel';

const Body = ({ children, group, singleView, jackpotComponent }: ISectionBody) => {
    const [backgroundSettings, hasBackground] = getBackgroundSettings(
        store.SETTINGS.value,
        group.toLowerCase(),
        Boolean(singleView),
    );
    return (
        <div
            style={!singleView ? backgroundSettings : {}}
            className={`egt_section_body egt_section_body_${singleView ? 'column' : 'row'} ${
                jackpotComponent ? 'with-jackpot-panel' : ''
            } ${
                hasBackground ? 'egt-section-body-with-background-image' : 'egt-section-body-without-background-image'
            }`}
        >
            {jackpotComponent && <BodyJackpotPanel group={group} jackpotComponent={jackpotComponent} />}
            {children}
        </div>
    );
};

export interface ISectionBody {
    group: string;
    jackpotComponent?: React.FunctionComponent;
    children?: React.ReactNode;
    singleView?: boolean;
}

export default Body;
